import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, MultiSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectContractAdvancedFilter } from 'shared/selectors/advancedFilters';
import { EContractType } from '../../../../../../../packages/api-models/common/json_query';
import { NonEmptyArray } from '../../../../../../../packages/JsonQuery';

export const ContractAdvancedContainer: FC = () => {
  const { label, value, options } = useSelector(selectContractAdvancedFilter);

  const onChange = useFilterChangeCallback();

  const handleContractChange = useCallback(
    (newValue: NonEmptyArray<EContractType> | null) => {
      onChange({ action: 'setContract', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <MultiSelectionAdvancedFilter value={value} options={options} onFilterChange={handleContractChange} />
    </AdvancedFilterRow>
  );
};
